import { useState, createContext } from 'react'
import { toast } from 'react-toastify'
import { authenticationService } from '@/services/Login'
import { authenticationServiceV2 } from '@/services/Login/v2/LoginService'

interface IProfile {
  children: React.ReactNode
}

type ApiVersionType = 'v1' | 'v2'

type ProfileContextData = {
  PROFILE_DATA: any
  CREATE_PROFILE: (params?: any) => Promise<void>
  GET_PROFILE: (params?: any, api_version?: ApiVersionType) => Promise<void>
  UPDATE_PROFILE: (params?: any) => Promise<void>
}

export const ProfileContext = createContext({} as ProfileContextData)

export function ProfileProvider({ children }: IProfile) {
  const [PROFILE_DATA, SET_PROFILE_DATA] = useState([])

  async function GET_PROFILE(params?: any, api_version?: ApiVersionType) {
    try {
      // prettier-ignore
      const service = api_version === 'v2'
        ? authenticationServiceV2
        : authenticationService

      const res = await service.getPermission(params)
      SET_PROFILE_DATA(res.data.data)
      return res.data.data
    } catch (e: any) {
      toast.error(e.message)
    }
  }

  async function CREATE_PROFILE(params?: any) {
    try {
      await authenticationService.newProfile(params)
      toast.success('Perfil criado com sucesso!')
    } catch (e: any) {
      toast.error(e.message)
    }
  }
  async function UPDATE_PROFILE(params?: any) {
    try {
      await authenticationService.updateProfile(params)
      toast.success('Perfil atualizado com sucesso!')
    } catch (e: any) {
      toast.error(e.message)
    }
  }

  return (
    <ProfileContext.Provider
      value={{
        GET_PROFILE,
        CREATE_PROFILE,
        UPDATE_PROFILE,
        PROFILE_DATA
      }}
    >
      {children}
    </ProfileContext.Provider>
  )
}
